import { makeStyles } from '@material-ui/styles';

import { neutral, red } from 'shared/styles/colors';
import { ELEVATED } from 'shared/styles/shadows';

export default makeStyles({
  module: {
    position: 'fixed',
    bottom: '4.5rem',
    left: '1rem',
    right: '1rem',
    padding: '0 0.75rem 1rem 0.75rem',
    fontFamily: 'PP Object Sans',
    borderRadius: '0.5rem',
    backgroundColor: neutral[10],
    boxShadow: ELEVATED.strongMinusY,
    border: `1px solid ${neutral[20]}`,
    '@media (width >= 60rem)': {
      gridArea: 'footer',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
    },
  },

  divider: {
    marginTop: '1rem',
    height: '1px',
    backgroundColor: neutral[30],
  },

  item: {
    paddingTop: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.5rem',
    color: neutral[80],
    backgroundColor: neutral[10],
    '& > span[data-is-negative="true"]': {
      color: red[60],
    },
    '&[data-is-zero="true"]': {
      color: neutral[50],
    },
  },

  details: {
    interpolateSize: 'allow-keywords',
    height: 0,
    overflow: 'clip',
    transition: 'height 0.4s ease-in-out',
    '&[data-is-open="true"]': {
      height: 'auto',
    },
  },

  totalStore: {
    paddingTop: '1rem',
    fontWeight: 500,
    color: neutral[100],
  },

  totalMain: {
    fontWeight: 500,
    color: neutral[100],
    '& > span': {
      display: 'inline-flex',
      gap: '0.5rem',
    },
  },
});
